exports.components = {
  "component---src-localization-en-pages-index-tsx": () => import("./../../../src/localization/en/pages/index.tsx" /* webpackChunkName: "component---src-localization-en-pages-index-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */)
}

